import styled from "@emotion/styled";

import { LandingPageFooter } from "../routes/projects/LandingPageFooter";
import { SidebarLogo } from "./SidebarLogo";
import { SidebarNav } from "./SidebarNav";
import { SIDEBAR_PADDING, SIDEBAR_WIDE_BREAKPOINT, SIDEBAR_WIDTH, SIDEBAR_WIDTH_WIDE } from "./sidebarStyles";
import { UserMenu } from "./UserMenu";
import { WorkspaceSwitcher } from "./WorkspaceSwitcher";

const Container = styled.aside`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 24px;

  flex: 0 0 ${SIDEBAR_WIDTH}px;
  width: ${SIDEBAR_WIDTH}px;
  height: 100%;

  padding: ${SIDEBAR_PADDING}px;

  background-color: ${({ theme }) => theme.surface};
  box-shadow: inset -6px 0 8px -8px ${({ theme }) => theme.surfaceSoft};

  @media (min-width: ${SIDEBAR_WIDE_BREAKPOINT}px) {
    flex-basis: ${SIDEBAR_WIDTH_WIDE}px;
    width: ${SIDEBAR_WIDTH_WIDE}px;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Spacer = styled.div`
  margin-block-start: auto;
`;

export const Sidebar = () => {
  return (
    <Container data-test="landing-sidebar">
      <SidebarLogo />

      <Section>
        <WorkspaceSwitcher />
        <SidebarNav />
      </Section>

      {/* TODO: waiting on docs site to be published <SupportSection /> */}

      <Spacer />

      <UserMenu />
      <LandingPageFooter />
    </Container>
  );
};
